import React from 'react';
import { observer } from 'mobx-react';
import { extendObservable, action } from 'mobx';
// import _ from 'lodash';
import GroupCarousel from './components/GroupCarousel';
import store from '../../../stores/store';
import { SORT_LAST_MODIFIED, SORT_AZ, SORT_ZA } from '../../../helpers/constants';

import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';

const GroupPanel = observer(
    class GroupPanel extends React.Component {
        constructor(props) {
            super(props);
            this.compState = extendObservable(this, {
                dropdownOpen: false,
                toggle: action(() => {
                    this.compState.dropdownOpen = !this.compState.dropdownOpen;
                }),
            });
        }

        onSortClick = type => {
            // check current type
            if (store.groups.sorted === type) return;
            // change type
            store.groups.sort(type);
            // move to first index
            if (this.carousel) this.carousel.slickGoTo(0);
        };

        renderHeader = () => {
            let arrowClass = 'toggle-arrow';
            let groupName = store.groups.getNameByIndex();

            if (!store.groups.collapsed) {
                arrowClass = 'toggle-arrow collapsed';
            }
            return (
                <div className="container-fluid mt-2">
                    <div className="row">
                        <div className="col pl-0">
                            <div
                                onClick={store.groups.togglePanel}
                                className={arrowClass}
                                id="groups-header-bar"
                                data-toggle="collapse"
                                href="#groupCarousel"
                                aria-expanded={store.groups.collapsed}
                                aria-controls="collapseGroupCarousel"
                            >
                                <h6>
                                    <span className="text-muted">Groups</span>
                                </h6>
                                {store.groups.selectedId !== null ? (
                                    <h6>
                                        <span className="text-muted carousel-breadcrumb">
                                            <b>{groupName ? ' / ' + groupName : ''}</b>
                                        </span>
                                    </h6>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-xs-auto ml-auto" id="sort-group">
                            <Dropdown
                                isOpen={this.compState.dropdownOpen}
                                toggle={this.compState.toggle}
                            >
                                <div
                                    className="sort-group-btn sort-group-icon"
                                    onClick={this.compState.toggle}
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded={this.compState.dropdownOpen}
                                >
                                    <span className="">{store.groups.sorted}</span>
                                </div>

                                <DropdownMenu right>
                                    <DropdownItem
                                        onClick={this.onSortClick.bind(this, SORT_LAST_MODIFIED)}
                                    >
                                        Last Modified
                                    </DropdownItem>
                                    <DropdownItem onClick={this.onSortClick.bind(this, SORT_AZ)}>
                                        A-Z
                                    </DropdownItem>
                                    <DropdownItem onClick={this.onSortClick.bind(this, SORT_ZA)}>
                                        Z-A
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            );
        };

        render() {
            return (
                <div>
                    {this.renderHeader()}
                    <div
                        className={`group-block ${store.groups.collapsed
                            ? 'collapsed-custom'
                            : 'expanded-custom'}`}
                        id="groupCarousel"
                    >
                        <div className="demo">
                            <GroupCarousel ref={car => (this.carousel = car)} />
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export default GroupPanel;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Group/GroupPanel.js